import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import ExtendHistoryTable from './ExtendHistoryTable';
import { PageStyled } from '../../styles';
import ExtendSettingsPanel from './ExtendSettingsPanel';
import useGetPackageSms from './services/hooks/useGetPackageSms';
import useGetPackageHistoryTopUp from './services/hooks/useGetPackageHistoryTopUp';

export const SMSPackagePage = () => {
  const { shopId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <PageStyled>
      <Container>
        <ExtendSettingsPanel />
        <ExtendHistoryTable />
      </Container>
    </PageStyled>
  );
};

const Container = styled.div`
  display: flex;
  padding: 16px;
  background: #fff;
  border-radius: 4px;
  gap: 24px;
`;
